import axios from 'axios';
import { API_VIRSION } from 'config';
// temporary user api
export const createSession = (body) => axios.post(`${API_VIRSION}/auth/login`, body);
